import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    loading: string;
    errorMessage: string;
    successMessage: string;
    view: string;
    viewAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast message while duplicating project */
            loading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseDuplicateProject.loading?c=6l6d61toa813", defaultMessage: "Duplicating Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast message when project duplication fails */
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseDuplicateProject.errorMessage?c=2fmpynhen4uyk", defaultMessage: "Couldn''t duplicate Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast message when project is successfully duplicated */
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseDuplicateProject.successMessage?c=21evl6huzy7o4", defaultMessage: "New Project created" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast action label for viewing the project created by duplication */
            view: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseDuplicateProject.view?c=3gggk12jubpod", defaultMessage: "View" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for viewing the project created by duplication */
            viewAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseDuplicateProject.viewAriaLabel?c=1ep7nm49f9y4m", defaultMessage: "View duplicated project" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
